import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import StudioMediaLibrariesTable from '../components/StudioMediaLibrariesTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import DismissableAlert from '../components/DismissableAlert';

import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    FormGroup,
    InputGroup
} from 'react-bootstrap';

import { translate } from 'react-i18next';

import './StudioMediaLibraries.css';

class StudioMediaLibraries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            medialibraries: [],
            page: props.page,
            pageCount: 0,
            limit: 40,
            search: props.search,
            selected: props.selected - 1,
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            }
        };
    }

    componentDidMount() {
        this.loadStudioMediaLibrariesFromServer();
    }

    saveMediaLibrary(medialibrary, newName) {
        var self = this;
        axios
            .put(`${config.baseURL}/studiolibraries/${medialibrary.uuid}`, {
                name: newName
            })
            .then(function(response) {
                self.loadStudioMediaLibrariesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    deleteMediaLibrary(medialibrary) {
        var self = this;
        axios
            .delete(`${config.baseURL}/studiolibraries/${medialibrary.uuid}`)
            .then(function(response) {
                self.loadStudioMediaLibrariesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadStudioMediaLibrariesFromServer() {
        var self = this;

        axios
            .get(`${config.baseURL}/studiolibraries`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    medialibraries: response.data.mediaLibraries,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url);

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadStudioMediaLibrariesFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');
        }

        window.history.pushState(null, null, url);

        event.preventDefault();
        this.loadStudioMediaLibrariesFromServer();
    };

    handleCreateClicked() {
        const { t } = this.props;

        this.dialog.show({
            body: t('StudioMediaLibrariesTable.medialibrary_name'),
            prompt: Dialog.TextPrompt({
                placeholder: t('StudioMediaLibrariesTable.name'),
                initialValue: ''
            }),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('MediaSnippet.add_medialibrary'),
                    dialog => this.didClickAdd(dialog.value),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    didClickAdd(newName) {
        const { t } = this.props;

        try {
            let self = this;
            axios
                .post(
                    `${config.baseURL}/studiolibraries`,
                    {
                        name: newName
                    }
                )

                .then(function(response) {
                    self.setState({
                        error: {
                            hidden: false,
                            title: `${t('CreateMediaLibrary.success')}:`,
                            style: 'success',
                            message: `${t(
                                'CreateMediaLibrary.created_message'
                            )}`
                        }
                    });

                    self.loadStudioMediaLibrariesFromServer();
                })
                .catch(function(err) {
                    self.setState({
                        error: {
                            hidden: false,
                            title: `${t('CreateMediaLibrary.error')}:`,
                            style: 'danger',
                            message: err.response.data.message || 'Unknown'
                        }
                    });
                });
        } catch (e) {
            this.setState({
                error: {
                    hidden: false,
                    title: `${t('CreateMediaLibrary.error')}:`,
                    style: 'danger',
                    message: `${t('CreateMediaLibrary.unknown_error')}`
                }
            });
        }
    }

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'StudioMediaLibraries.title'
        )}`;

        const user = this.state.user;

        return (
            <div className="StudioMediaLibraries">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('StudioMediaLibraries.title')}{' '}
                                    <small>
                                        {this.state.organisation_name}
                                    </small>
                                    {this.state.userIsAuthorized(user, [
                                        'staff_super_admin'
                                    ]) ? (
                                        <Button
                                            className="btn-primary "
                                            onClick={() =>
                                                this.handleCreateClicked()
                                            }
                                        >
                                            <em className="fa fa-plus fa-fw" />{' '}
                                            {t('MediaSnippet.add_medialibrary')}
                                        </Button>
                                    ) : null}
                                </h1>

                                <ol className="breadcrumb">
                                    <li className="active">
                                        <i className="fas fa-palette" />{' '}
                                        {t('StudioMediaLibraries.title')}
                                    </li>
                                </ol>

                                <DismissableAlert
                                    title={this.state.error.title}
                                    message={this.state.error.message}
                                    hidden={this.state.error.hidden}
                                    style={this.state.error.style}
                                />
                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <form
                                                    role="search"
                                                    onSubmit={this.handleSubmit}
                                                >
                                                    <FormGroup controlId="search">
                                                        <InputGroup>
                                                            <FormControl
                                                                type="text"
                                                                value={
                                                                    this.state
                                                                        .search
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                                placeholder={t(
                                                                    'Search'
                                                                )}
                                                            />
                                                            <InputGroup.Button>
                                                                <Button
                                                                    onClick={
                                                                        this
                                                                            .handleSubmit
                                                                    }
                                                                >
                                                                    <i className="glyphicon glyphicon-search" />
                                                                </Button>
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </form>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <StudioMediaLibrariesTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        medialibraries={
                                            this.state.medialibraries
                                        }
                                        onSave={this.saveMediaLibrary.bind(
                                            this
                                        )}
                                        onDelete={this.deleteMediaLibrary.bind(
                                            this
                                        )}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(StudioMediaLibraries);
